'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NewNavigationBar = require('../NewNavigationBar');

var _NewNavigationBar2 = _interopRequireDefault(_NewNavigationBar);

var _FavoritesBar = require('../FavoritesBar');

var _FavoritesBar2 = _interopRequireDefault(_FavoritesBar);

var _userPropType = require('../PropTypes/userPropType');

var _userPropType2 = _interopRequireDefault(_userPropType);

var _entitlementsPropType = require('../PropTypes/entitlementsPropType');

var _entitlementsPropType2 = _interopRequireDefault(_entitlementsPropType);

var _serviceConfigurationPropType = require('../PropTypes/serviceConfigurationPropType');

var _serviceConfigurationPropType2 = _interopRequireDefault(_serviceConfigurationPropType);

var _settingsPropType = require('../PropTypes/settingsPropType');

var _settingsPropType2 = _interopRequireDefault(_settingsPropType);

var _favoritesPropType = require('../PropTypes/favoritesPropType');

var _favoritesPropType2 = _interopRequireDefault(_favoritesPropType);

var _NotificationBar = require('../NotificationBar');

var _NotificationBar2 = _interopRequireDefault(_NotificationBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageContainer = function (_Component) {
  (0, _inherits3.default)(PageContainer, _Component);

  function PageContainer() {
    (0, _classCallCheck3.default)(this, PageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (PageContainer.__proto__ || (0, _getPrototypeOf2.default)(PageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(PageContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          user = _props.user,
          serviceConfig = _props.serviceConfig,
          settings = _props.settings,
          entitlements = _props.entitlements,
          favorites = _props.favorites,
          smallNotification = _props.smallNotification,
          largeNotification = _props.largeNotification,
          footer = _props.footer,
          largeFavoritesBar = _props.largeFavoritesBar;


      return _react2.default.createElement(
        'div',
        { className: 'quiver-page-container' },
        _react2.default.createElement(
          'div',
          { className: 'quiver-page-container__top' },
          _react2.default.createElement(_NotificationBar2.default, { largeNotification: largeNotification }),
          _react2.default.createElement(_NewNavigationBar2.default, {
            user: user,
            entitlements: entitlements,
            smallNotification: smallNotification,
            serviceConfig: serviceConfig,
            settings: settings,
            favorites: favorites
          }),
          _react2.default.createElement(_FavoritesBar2.default, {
            settings: settings,
            entitlements: entitlements,
            favorites: favorites,
            user: user,
            large: largeFavoritesBar
          })
        ),
        _react2.default.createElement(
          'main',
          { className: 'quiver-page-container__content', role: 'main' },
          children
        ),
        footer
      );
    }
  }]);
  return PageContainer;
}(_react.Component);

PageContainer.propTypes = {
  children: _propTypes2.default.node,
  user: _userPropType2.default,
  serviceConfig: _serviceConfigurationPropType2.default,
  settings: _settingsPropType2.default,
  entitlements: _entitlementsPropType2.default,
  favorites: _favoritesPropType2.default,
  smallNotification: _propTypes2.default.node,
  largeNotification: _propTypes2.default.node,
  footer: _propTypes2.default.node,
  largeFavoritesBar: _propTypes2.default.bool
};
PageContainer.defaultProps = {
  children: null,
  user: null,
  serviceConfig: null,
  settings: null,
  entitlements: [],
  favorites: [],
  smallNotification: null,
  largeNotification: null,
  footer: null,
  largeFavoritesBar: false
};
exports.default = PageContainer;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PageContainer/PageContainer.js
// module id = 624
// module chunks = 11